import { applyMiddleware, createStore, compose } from 'redux';
import rootReducer from '.';
import reduxImmuteableStateInvariant from 'redux-immutable-state-invariant';
import thunk from 'redux-thunk';
import { initialState as initialStoreState } from './initialState';
const composeEnhancers = (window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
export const store = createStore(rootReducer, initialStoreState, composeEnhancers(applyMiddleware(thunk, reduxImmuteableStateInvariant({ ignore: ["groupOptions"] }))));
export default store;
